var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ul", { staticClass: "title-nav" }, [
        _c("li", [
          _c(
            "div",
            {
              staticClass: "back-btn",
              on: {
                click: function($event) {
                  return _vm.routeBack()
                }
              }
            },
            [
              _c("i", { staticClass: "material-icons md-18" }, [
                _vm._v("keyboard_arrow_left")
              ])
            ]
          ),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [_vm._v("ACTIVE EMAIL")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("div", { staticClass: "text-break property-locked" }, [
            _vm._v("\n\t\t\t\t" + _vm._s(_vm.agent.email) + "\n\t\t\t")
          ])
        ]),
        _vm._v(" "),
        _vm.mode == "view"
          ? _c("div", { staticClass: "property-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light btn-sm float-right",
                  on: { click: _vm.editShow }
                },
                [_vm._v("Change Email")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.mode == "edit"
        ? _c(
            "form",
            {
              staticClass: "category form-group",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitChange.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "category-title",
                  attrs: { for: "signUpEmail" }
                },
                [_vm._v("NEW EMAIL")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "property-row" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newEmail,
                      expression: "newEmail"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.error },
                  attrs: {
                    type: "email",
                    id: "email",
                    "aria-describedby": "emailHelp",
                    placeholder: "Enter new email"
                  },
                  domProps: { value: _vm.newEmail },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newEmail = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-feedback" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(_vm.error) + "\n\t\t   ")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "property-row" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.editCancel.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-dark float-right",
                    attrs: { type: "submit" }
                  },
                  [_vm._v("Update")]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("contentLoading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c("contentAlert", { attrs: { alert: _vm.alert } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-label" }, [
      _c("i", { staticClass: "material-icons md-18" }, [_vm._v("email")]),
      _vm._v(" EMAIL")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63c1d42c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63c1d42c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agent/agent-email.vue
// module id = null
// module chunks = 